export const TIMEDEAD_DEFAULT_FOR_ALERT = 3000;

export enum AlertsTypes {
	SUCCESS = 'success',
	FAILURE = 'failure',
	WARNING = 'warning'
}

export enum NotificationTypes {
	DEFAULT = 'default',
	URGENT = 'urgent'
}

export enum NotiticationChat {
	ERROR_UNSUPPORTED_FORMAT = 'Данный формат не поддерживается'
}
